<template>
    <div class="agent-assistance">
        <v-page-header
            :back="{
                title: $t('企业微信账号'),
                goBack: goback,
            }"
            :title="$t('企微智能辅助')"
        >
            <lamp-tip>
                <i18n-t path="获取聊天工具栏链接后，需前往企微后台进行配置，请先查看并按照{guide}配置" tag="span">
                    <a slot="guide" href="https://api.qidian.qq.com/wiki/doc/open/flakoerkg1lmshrvyvi5" target="_blank">{{ $t('操作指引') }}</a>
                </i18n-t>
            </lamp-tip>
        </v-page-header>
        <v-table
            :data="options"
            class="agent-assistance-table"
        >
            <v-table-column
                v-for="column in columns"
                :key="column.label"
                :column-key="column.columnKey"
                :label="column.label"
                :width="column.width"
            />
            <v-table-column
                width="200"
                column-key="autoMatchSwitch"
                :render-header="renderHeader"
            >
                <div slot="header">
                    <div class="agent-assistance-header">
                        <span>{{ $t('开启自动匹配') }}</span>
                        <v-icon
                            v-tip:header.hover
                            name="basic_help_line"
                            remote
                        />
                        <v-tip
                            ref="header"
                            placement="top"
                        >
                            {{ $t('开启后，系统自动匹配访客消息并生成推荐答案，提升接待效率。') }}
                        </v-tip>
                    </div>
                </div>
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <v-switch
                        v-model="props.row.autoMatchSwitch"
                        @click="handleSwitchChange($event, props.row)"
                    />
                </template>
            </v-table-column>
            <v-table-column
                width="150"
                column-key="status"
                :label="$t('服务状态')"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <v-tag
                        :kind="props.row.status === 1 ? 'success' : 'warning'"
                        :status-text="props.row.status === 1 ? $t('已上线') : $t('规划中')"
                        type="status"
                    />
                </template>
            </v-table-column>
            <v-table-column
                key="opt"
                width="200"
                column-key="operate"
                :label="$t('操作')"
                name="operate"
                align="left"
            >
                <template
                    slot="cell"
                    slot-scope="props"
                >
                    <v-copy v-model="props.row.link" kind="text" @success="copySuccess">
                        <v-button
                            class="table-action-copy"
                            type="link"
                            kind="primary"
                        >
                            {{ $t('复制链接') }}
                        </v-button>
                    </v-copy>
                    <v-button
                        class="table-action-associate"
                        type="link"
                        kind="primary"
                        @click="associate(props.row)"
                    >
                        {{ $t('关联机器人') }}
                    </v-button>
                </template>
            </v-table-column>
        </v-table>
        <AssociateRobot ref="associate" @confirm="confirm" />
        <v-dialog v-model="confirmDialog" kind="modal" :title="$t('确定要开启自动匹配吗？')" class="switch-confirm-dialog" @confirm="confirm(null, true)">
            <div>
                <div class="switch-confirm-dialog-header">
                    {{ $t('请先完成会话内容存档配置，再开启自动匹配，否则不会生效。可点击前往配置') }}
                    <a target="_blank" href="/mng/weworkAccount/index">{{ $t('【企业管理-企业微信账号】') }}</a>
                </div>
            </div>
            <div class="content">
                <img :src="require('./assets/wework.png')" class="content-img">
            </div>
        </v-dialog>
    </div>
</template>

<script>
import LampTip from '@/components/lamp-tip';
import AssociateRobot from '@/components/associate-robot';

export default {
    components: { LampTip, AssociateRobot },

    data() {
        return {
            confirmDialog: false,
            options: [],
            robotConfig: {},
        };
    },
    computed: {
        columns() {
            return [
                {
                    label: this.$t('辅助类型'),
                    columnKey: 'name',
                    width: 200,
                },
                {
                    label: this.$t('描述'),
                    columnKey: 'desc',
                },
            ];
        },
    },
    created() {
        this.fetchList();
    },

    methods: {
        renderHeader() {
            const directives = [
                {
                    name: 'tip',
                    value: 'header',
                    modifiers: {
                        hover: true,
                    },
                },
            ];
            return (
                <div class="agent-assistance-header">
                    <span>{this.$t('开启自动匹配')}</span>
                    <v-icon
                        {...{ directives }}
                        name="basic_help_line"
                        remote
                    ></v-icon>
                    <v-tip
                        ref="header"
                        placement="top"
                    >
                        {this.$t('开启后，系统自动匹配访客消息并生成推荐答案，提升接待效率。')}
                    </v-tip>
                </div>
            );
        },
        fetchList() {
            this.$ajax.gatewayPost('/v1/kf/receptionConf/wecomAssist/list', {
                suiteId: this.$route.query?.suiteId,
            }).then((res) => {
                this.options = res.data?.records || [];
            })
            .catch((err) => {
                this.$message.error(err.message || this.$t('获取页面数据失败'));
            });
        },
        associate(config) {
            this.robotConfig = config;
            this.$refs.associate.open(this.robotConfig.associateData);
        },
        handleSwitchChange(event, val) {
            event.preventDefault();
            if (!val.associateData) {
                this.$message.error(this.$t('请先关联机器人再打开自动匹配。'));
                return;
            }
            this.robotConfig = val;
            if (!val.autoMatchSwitch) {
                this.confirmDialog = true;
            } else {
                this.confirm(null, !val.autoMatchSwitch);
            }
        },
        confirm(robotId, switchVal) {
            const params = {
                id: this.robotConfig.id,
                autoMatchSwitch: switchVal !== undefined ? Number(switchVal) : this.robotConfig.autoMatchSwitch,
                associateType: this.robotConfig.associateType || 4,
                associateData: robotId || this.robotConfig.associateData,
            };
            this.$ajax.gatewayPost('/v1/kf/receptionConf/wecomAssist/update', params).then((res) => {
                robotId && this.$message.success(this.$t('关联成功'));
                this.fetchList();
            })
            .catch((err) => {
                this.$message.error(err.message || this.$t('获取页面数据失败'));
            });
        },
        copySuccess() {
            this.$message.success(this.$t('复制成功，请尽快前往企微后台完成配置。'));
        },
        goback() {
            window.location.href = '/mng/weworkAccount/index/app';
        },
    },
};
</script>
<style lang="less" scoped>
@import './agent-assistance.less';
</style>
